import helper, { bindUrl } from "../helper";

/**
 * 登录
 */
export const login = function(loginName, password, loginType = 0, openId) {
  return helper.post("/v1/user/login", {
    loginName,
    password,
    loginType,
    openId
  });
};

/**
 * 交易员登录
 */
export const traderLogin = function(params) {
  return helper.post("/uaa/user/login", params);
};

/**
 * 登录后角色设置
 */
export const choiceRole = function(roleId) {
  return helper.get(`/v1/user/choice/${roleId}`);
};
/**
 * 删除
 * @param roleId
 * @returns {*}
 */
export const deleteUser = function(userId) {
  return helper.delete(`/v1/user/${userId}`);
};

/**
 * 当前用户角色和对应权限
 */
export const currentRoles = function() {
  return helper.get("/v1/role/currentRoles");
};

/**
 * 登出
 */
export const logout = function() {
  return Promise.resolve("");
};

/**
 * 添加用户
 */
export const add = function(user) {
  return helper.post("/v1/user", Object.assign({}, user));
};

/**
 * 查询用户
 */
export const getUserList = (user, pageQuery) => {
  return helper.get(
    "/v1/user",
    {
      ...user,
      ...pageQuery
    },
    false
  );
};

export const update = function(user) {
  return helper.put("/v1/user", Object.assign({}, user));
};

/**
 * 更新密码
 * PUT /v1/user/password
 * @param {UserPasswordParam} bodyParams - update
 */
export function updatePassword(bodyParams) {
  return helper.request({
    url: bindUrl("/v1/user/password", {}),
    method: "PUT",
    data: bodyParams
  });
}

/**
 * 初始化
 * PUT /v1/user/password/{id}
 * @param {Object} pathParams
 * @param {number} pathParams.id - 用户编号
 */
export function initPassword(pathParams) {
  return helper.request({
    url: bindUrl("/v1/user/password/{id}", pathParams),
    method: "PUT"
  });
}

export const getUserOrgInfo = function(params) {
  return helper.get("/v1/user/getUserOrgInfo", params);
};

/**
 * 获取用户列表
 * GET /v1/user
 */
export const traderList = function(params) {
  return helper.request({
    url: bindUrl("/v1/user/salesman", params),
    method: "GET"
  });
};
